import React from 'react';
import "../CSS_stuff/FormatUpcomingBook.css";
// If you want to show an image later, import it and set imageSrc below:
// import myImage from '../assets/2025-Upcoming-Books.jpg';

function UpcomingBooks() {

  // Optional image: set to an imported image (myImage) when you want to display it.
  // Leave as null to hide the image.
  const imageSrc = null; // e.g. set to myImage to enable

  // Caption to show at the top of the upcoming books section
  const caption = "";

  // Add your upcoming books list here (title + abbreviation)
  const upcoming = [
    {
      month: "March 21, 2026",
      sections: [{
      
        label: "Rerelease of the Knightness of the Realm saga: The SECRETS of DRAGON MOUNTAIN",
        books:[
        { title: "An Altogether-Curious Altercation",},
        { title: "An All-Too-Obvious Choice",},
        { title: "An Entirely-Rational(ized) Decision",},]},
      
      {
        label: "Wedding of the Season trilogy PREMIER",
        books: [{ title: "An All-Too-Easy Answer", }]
      },
        {
          label: "Standalone release",
          books: [
            { title: "Scaredy Cat", },
            { title: "The Fall of Taridawil", }
          ]
        },
        {
          label: "Another Standalone release",
          books: [
            { title: "A Not-So-Sacrificial Maiden", }
          ]
        }
      ]},
      

    {
      month: "April 2026",
      sections: [
        {
          label: "Wedding of the Season trilogy continued",
          books: [{ title: "An Unreasonably-Traumatic Celebration", }]
        },
        {
          label: "Rerelease of the Knightness of the Realm saga: The HEIR’s JOURNEY",
          books: [
            { title: "A Not-So-Simple Mission", },
            { title: "An Entirely-Unexpected Revelation", },
            { title: "An All-Too-Surprising Homecoming", }
          ]
        },
        {
          label: "Standalone release",
          books: [
            { title: "Scaredy Cat" },
            { title: "The Fall of Taridawil" },
            { title: "A Not-So-Sacrificial Maiden"},
          ]
        },
        {
          label: "Dragons & Damage Control from the Prankster Prince PREMIER",
          books: [
            { title: "A School for Pranks & Dragons", }
          ]
        }
      ]
    },

    {
      month: "May 2026",
      sections: [
        {
          label: "An Interesting Interlude trilogy PREMIER",
          books: [{ title: "A Secretly-Sensitive Past", }]
        }
      ]
    },
    {
      month: "June 2026",
      sections: [
        {
          label: "An Interesting Interlude trilogy continued",
          books: [{ title: "A Secretly-Sensitive Past", }]
        }
      ]
    },
    {
      month: "July 2026",
      sections: [
        {
          label: "An Interesting Interlude trilogy continued",
          books: [{ title: "A Fairly-Friendly Family", }]
        }
      ]
    },
    {
      month: "August 2026",
      sections: [
        {
          label: "Wedding of the Season trilogy continued",
          books: [{ title: "An Unexpectedly-Exciting Evening", }]
        }
      ]
    },
    {

      caption: "September 2026: premire of a new Chronicles of Ilseador miniseries!!!",
    },
    {
      caption: "October 2026: Dragons & Damage Control book 2",
    },
    { 
      caption: "November 2026: premire of a new Knightess miniseries!!!",
    }
    
  ];

  return (
    <div className="upcoming-page">
      {/* Image will render only if imageSrc is set */}
      {imageSrc && (
        <div className="image-container">
          <img src={imageSrc} alt="Upcoming books banner" />
        </div>
      )}

      <section className="upcoming-list" aria-labelledby="upcoming-heading">
        {/* Caption shown above the heading */}
        <p className="upcoming-caption">{caption}</p>

        <h2 id="upcoming-heading">Upcoming Books</h2>
        <ul>
          {upcoming.map((entry, mIdx) => (
            <li key={mIdx} className="upcoming-month-item">
              {entry.month && <h3>{entry.month}</h3>}

              {entry.sections?.map((section, sIdx) => (
                <div key={sIdx}>
                  <h4>{section.label}</h4>
                  <ul>
                    {section.books?.map((book, bIdx) => (
                      <li key={bIdx}>
                        {book.abbr ? <strong>{book.abbr}</strong> : null}
                        {book.abbr ? " — " : ""}
                        {book.title}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              {entry.caption && <p className="upcoming-caption-inline">{entry.caption}</p>}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default UpcomingBooks;